import { render, staticRenderFns } from "./DeleteConfirmPosition.vue?vue&type=template&id=4d438681"
import script from "./DeleteConfirmPosition.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports